export default __webpack_public_path__ + "static/media/Leo.bb0ae6b6.jpg";